import { isEmpty } from "lodash";
import { PremiseType } from "../../__generated__/graphql-global-types";
export var PREMISE_SETUP;
(function (PREMISE_SETUP) {
    PREMISE_SETUP["PERFHAMMER"] = "perfhammer";
    PREMISE_SETUP["NONE"] = "None";
})(PREMISE_SETUP || (PREMISE_SETUP = {}));
export var requestDataPremiseTypes = [
    PremiseType.perfhammer_sqs,
    PremiseType.perfhammer_apis
];
export var queueUrlPremiseTypes = [
    PremiseType.perfhammer_sqs
];
export var isRequestDataValid = function (premise) {
    return isRequestDataInputValid(premise) && !isEmpty(premise.inputData.request_data);
};
export var isRequestDataInputValid = function (premise) {
    return premise.inputType === PremiseType.perfhammer_sqs ||
        (premise.inputType === PremiseType.perfhammer_apis &&
            ["POST", "PUT"].includes(premise.inputData.request_method));
};
export var isUserCountValid = function (premise) {
    return premise.inputData.user_count && premise.inputData.user_count > 0;
};
export var isQueueUrlValid = function (premiseType) {
    return queueUrlPremiseTypes.includes(premiseType);
};
export var updatePremiseRequestMethod = function (premise) {
    if (premise &&
        premise.inputType === PremiseType.perfhammer_apis &&
        !premise.inputData.request_method) {
        premise.inputData.request_method = isEmpty(premise.inputData.request_data)
            ? "GET"
            : "POST";
    }
};
